import * as rrd from 'react-router-dom';

import { supportConfig } from '@/config';

const { Link } = rrd.default ?? rrd;

const SupportCard = () => {
  if (supportConfig.hasSupport) {
    return (
      <div className="border rounded p-3 mt-3 d-flex align-items-center justify-content-between gap-3 flex-nowrap">
        <p className="text-muted mb-0">
          Loved the seamless transfer? Your support fuels future enhancements!
        </p>

        <Link
          to="/support"
          className="btn btn-sm btn-outline-custom btn-outline-accent flex-shrink-0"
        >
          Support <i className="fas fa-heart" aria-hidden="true"></i>
        </Link>
      </div>
    );
  }

  return null;
};

export default SupportCard;
